App.ProductReview = (function () {
  function initShow() {
    $(document).on("click", "[data-action=new_reviewer_detail_comment]", function (e) {
      e.preventDefault();
      url = $(this).data('url');
      openForm(url);
    })
  }

  function openForm(url) {
    $.get(url, function (data) {
      var form = $(data);
      vex.open({
        unsafeContent: data
      });
    });
  }

  return {
    initShow: initShow
  }
})();